import React from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import { useState, useEffect, useCallback } from 'react';
import RadialChart1 from "./UserPanelChart1";
import UserPanelChart from "./UserPanelChart";
import axios from "axios";

const UserPanel = () => {
  const authUser = JSON.parse(localStorage.getItem("authUser"));
  const token = authUser?.token;
  const [orderStatusesCount, setOrderStatusesCount] = useState({});

  const fetchOrderStatusesCount = useCallback(async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASEURL}/orders/get-order-statuses-count`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await response.data;
      setOrderStatusesCount(data);
    } catch (error) {
      console.error(error);
    }
  }, [token]);

  useEffect(() => {
    if (token) {
      fetchOrderStatusesCount();
    }
  }, [token, fetchOrderStatusesCount]);

  return (
    <React.Fragment>
      <Row>
        {/* Total Orders */}
        <Col xl={3} sm={6} className="mb-4">
          <a href="/orders">
            <Card className="order-data-card mb-0">
              <CardBody>
                <div className="d-flex text-muted">
                  <div className="flex-shrink-0 me-3 align-self-center">
                    <div id="radialchart-1" className="apex-charts" dir="ltr">
                      <RadialChart1 totalOrders={orderStatusesCount.totalOrders} />
                    </div>
                  </div>
                  <div className="flex-grow-1 overflow-hidden">
                    <p className="">Total Orders</p>
                    <h5 className="">{orderStatusesCount.totalOrders || 0}</h5>
                  </div>
                </div>
              </CardBody>
            </Card>
          </a>
        </Col>

        {/* Pending Orders */}
        <Col xl={3} sm={6} className="mb-4">
          <Card className="order-data-card mb-0">
            <CardBody>
              <div className="d-flex text-muted">
                <div className="flex-shrink-0 me-3 align-self-center">
                  <UserPanelChart
                    totalOrders={orderStatusesCount.totalOrders}
                    statusCount={orderStatusesCount.pendingOrders}
                    color="#005254"
                  />
                </div>
                <div className="flex-grow-1 overflow-hidden">
                  <p className="">Pending</p>
                  <h5 className="">{orderStatusesCount.pendingOrders || 0}</h5>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>

        {/* Approved Orders */}
        <Col xl={3} sm={6} className="mb-4">
          <Card className="order-data-card mb-0">
            <CardBody>
              <div className="d-flex text-muted">
                <div className="flex-shrink-0 me-3 align-self-center">
                  <UserPanelChart
                    totalOrders={orderStatusesCount.totalOrders}
                    statusCount={orderStatusesCount.approvedOrders}
                    color="#f1b44c"
                  />
                </div>
                <div className="flex-grow-1 overflow-hidden">
                  <p className="">Approved</p>
                  <h5 className="">{orderStatusesCount.approvedOrders || 0}</h5>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>

        {/* Dispatched Orders */}
        <Col xl={3} sm={6} className="mb-4">
          <Card className="order-data-card mb-0">
            <CardBody>
              <div className="d-flex text-muted">
                <div className="flex-shrink-0 me-3 align-self-center">
                  <UserPanelChart
                    totalOrders={orderStatusesCount.totalOrders}
                    statusCount={orderStatusesCount.dispatchedOrders}
                    color="#57BABA"
                  />
                </div>
                <div className="flex-grow-1 overflow-hidden">
                  <p className="">Dispatched</p>
                  <h5 className="">{orderStatusesCount.dispatchedOrders || 0}</h5>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>

        {/* In Transit Orders */}
        <Col xl={3} sm={6} className="mb-4">
          <Card className="order-data-card mb-0">
            <CardBody>
              <div className="d-flex text-muted">
                <div className="flex-shrink-0 me-3 align-self-center">
                  <UserPanelChart
                    totalOrders={orderStatusesCount.totalOrders}
                    statusCount={orderStatusesCount.inTransitOrders}
                    color="#50a5f1"
                  />
                </div>
                <div className="flex-grow-1 overflow-hidden">
                  <p className="">In Transit</p>
                  <h5 className="">{orderStatusesCount.inTransitOrders || 0}</h5>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>

        {/* Delivered Orders */}
        <Col xl={3} sm={6} className="mb-4">
          <Card className="order-data-card mb-0">
            <CardBody>
              <div className="d-flex text-muted">
                <div className="flex-shrink-0 me-3 align-self-center">
                  <UserPanelChart
                    totalOrders={orderStatusesCount.totalOrders}
                    statusCount={orderStatusesCount.deliveredOrders}
                    color="#34c38f"
                  />
                </div>
                <div className="flex-grow-1 overflow-hidden">
                  <p className="">Delivered</p>
                  <h5 className="">{orderStatusesCount.deliveredOrders || 0}</h5>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>

        {/* Rejected Orders */}
        <Col xl={3} sm={6} className="mb-4">
          <Card className="order-data-card mb-0">
            <CardBody>
              <div className="d-flex text-muted">
                <div className="flex-shrink-0 me-3 align-self-center">
                  <UserPanelChart
                    totalOrders={orderStatusesCount.totalOrders}
                    statusCount={orderStatusesCount.rejectedOrders}
                    color="#FF6A56"
                  />
                </div>
                <div className="flex-grow-1 overflow-hidden">
                  <p className="">Rejected</p>
                  <h5 className="">{orderStatusesCount.rejectedOrders || 0}</h5>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default UserPanel;
